import "./Сonditions.css";
import { useNavigate } from "react-router-dom";
import speaker from "../../../image/speaker-icon.svg";

function Conditions() {

    const navigate = useNavigate();

  function goRegister() {
    navigate ("/sign-up");
  }



  return (
    <section className="conditions">
      <div className="conditions-container">
        <img
          className="conditions-container__img"
          src={speaker}
          alt="иконка"
        ></img>
        <p className="conditions-container__description">
          Все блоки проходятся строго по&nbsp;порядку. Пропустить какой-то блок
          или начать обучение с&nbsp;середины нельзя, даже если
          вы&nbsp;считаете, что уже знаете какую-то часть материала. Только так
          мы&nbsp;можем гарантировать, что вы&nbsp;получите все знания,
          предусмотренные учебной программой.
        </p>
        <button onClick={goRegister} className="description-block__button description-block__button_conditions">
          Начать обучение
        </button>
      </div>
    </section>
  );
}

export default Conditions;
